import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 77.9 58.55"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m77.8 28.3-1.8-.1c-3.87 0-7-3.13-7-7C69.1 13.3 64.6.7 46.8 0H16.1l-.4 1.5h25.8c2.6.1 4.4 2 3.6 5.1l-4.6 16.85a6.786 6.786 0 0 1-6.4 4.8c-4.7-.4-3.4-4.9-3.4-4.9l2.1-7.7a2.887 2.887 0 0 0-2.8-3.9H12.9l-.4 1.5h7.3c2.7.1 3.3 2.1 2.8 3.9 0 0-.9 3.2-2 7.2a5.188 5.188 0 0 1-5.2 4H8.3l-.5 1.8h6.7c.8 0 4.4.1 3.3 4s-2 7.2-2 7.2a5.308 5.308 0 0 1-4.9 3.9H3.6l-.4 1.5h17.1a5.857 5.857 0 0 0 5-3.9l2.1-7.7a6.8 6.8 0 0 1 6.1-4.9s4.8-.3 3.7 4.8l-4.6 16.8a7.078 7.078 0 0 1-6.4 5.1H.4l-.4 1.6h30.8c18.2-.7 29.6-13.3 33.9-21.2 0 0 3.4-6.4 10.8-7l1.8-.1c.08 0 .15-.04.2-.1.1-.3.4-1.5.4-1.6s0-.2-.1-.2",
      style: {"fill":"#0a468c"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "MH-logo"}) } }